export default {
  yourSkills: "Ihre Kompetenzen",
  skills: "Kompetenzen",
  skill: "Kompetenz",
  synthesis: {
    synthesis: "Zusammenfassung",
    attachments: "Anhänge",
    evolution: "Entwick.",
    noAttachment: "Kein Anhang",
    notEvaluated: "Nicht bewertet",
    notEvaluatedShort: "—",
    levelOf: ({ named }) => `Niveau ${named("value")} von ${named("max")}`,
    collapsePeriod: ({ named }) => `Zeitraum ${named("name")} ausblenden`,
    expandPeriod: ({ named }) => `Zeitraum ${named("name")} anzeigen`,
    skillCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "Kompetenzen" : "Kompetenz"}`,
    attachmentCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "Anhänge" : "Anhang"}`,
    showMoreAttachments: ({ named }) =>
      `${named("count")} ${named("count") > 1 ? "weitere Anhänge" : "weiteren Anhang"} anzeigen`,
    showLessAttachments: "Weniger Anhänge anzeigen",
    mode: {
      title: "Zusammenfassungsmodus",
      avg: "Durchschnitt",
      max: "Höchstnote",
      last: "Letzte Bewertung",
    },
    hide: "Ausblenden",
    loading: "Kompetenzzusammenfassung wird geladen...",
    seeProgression: "Entwicklung anzeigen",
  },
  last_skill_update: "Letzte Speicherung",
  duration: "Dauer",
  Category: "Kategorie",
  "Skills saved successfully": "Kompetenzen erfolgreich gespeichert",
  next: "Nächste",
  previous: "Vorherige",
  seeHistoric: "Verlauf anzeigen",
  resetSkill: "Kompetenz zurücksetzen",
  justificativePieceSend: "Belege gesendet",
  sendJustificativePiece: "Belege senden",
  justificativeFileDeposited: ({ plural, named }) =>
    plural([`${named("count")} Datei hochgeladen`, `${named("count")} Dateien hochgeladen`]),
  impossibleJustificativeSending: "Belege können erst nach der Benotung hinzugefügt werden",
  stats: {
    no_data: "Noch keine Daten eingegeben",
  },
  no_skills: "Für diese Kategorie ist keine Kompetenz eingetragen",
  no_skill_available: "Derzeit ist keine Kompetenz eingetragen",
  no_skill_complete: "Keine Kompetenz wurde ausgefüllt",
  skill_chart: "Kompetenzdiagramm",
  skill_category_chart: "Radar nach Kompetenzblock",
  skill_progression_chart: "Kompetenzfortschritt",
  skill_chart_pdf_name: "kompetenz-diagramm",
  referential_visible: ({ plural }) => plural(["Referential aktiv", "Referential inaktiv"]),
  session_visible: ({ plural }) => plural(["Sitzung aktiv", "Sitzung inaktiv"]),
  generate_all_rncp_referential: "Alle France Compétences-Referentiale generieren",
  empty_config: "Achtung: Die Konfiguration des Kompetenzmoduls ist noch nicht abgeschlossen",
  admin_config: {
    enable_on_all_training_course: {
      title: "Admin-Konfiguration auf alle aktiven Gruppen anwenden",
      confirm: {
        title: "Admin-Konfiguration verwenden?",
        subtitle:
          "Achtung: Dies betrifft die Admin-Konfiguration auf alle aktiven Gruppen, auch solche mit einer personalisierten Konfiguration",
      },
    },
    disable_on_all_training_course: {
      title: "Personalisierte Konfiguration auf alle aktiven Gruppen anwenden",
      confirm: {
        title: "Personalisierte Konfiguration verwenden?",
        subtitle:
          "Achtung: Dies betrifft die personalisierte Konfiguration auf alle aktiven Gruppen, auch solche mit der Admin-Konfiguration",
      },
    },
  },
  skill_admin_config_in_use: "Sie verwenden derzeit die Admin-Konfiguration für die Zeiträume.",
  notEvaluable: "Nicht bewertbar",
  notEvaluableAbbr: "NB",
  gradingScale: "Bewertungsskala",
  skillLevelOption: ({ named }) => `Stufe ${named("level")}`,
};
